import React, { useMemo } from 'react';
import { Translate, TranslateScope } from '@pegasus/translation';
import { useConfig } from '@browsing/config';
import { ResponsiveCarousel, CarouselItem } from '@lux-sandbox/carousel';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { ArticleCompactInlineCard } from '@browsing/components';
import { useTrackViewItemList, trackSelectItem, trackSelectContent } from '@browsing/tracking';
import { CatalogType, NavigationSourceType } from '@browsing/utils';
import * as S from './styles';
export var Carousel = function (_a) {
    var carouselItems = _a.carouselItems, isInView = _a.isInView;
    var config = useConfig();
    var slicedCarouselItems = useMemo(function () { return (Array.isArray(carouselItems) ? carouselItems.slice(0, 9) : []); }, [carouselItems]);
    useTrackViewItemList({
        items: slicedCarouselItems,
        payload: {
            element: 'tp4u',
            context: 'tp4u',
            item_list_name: 'tp4u',
        },
        itemMapper: function () { return ({
            item_list_name: 'tp4u',
            recommended: 'reco',
        }); },
        triggerCondition: slicedCarouselItems.length !== 0 && isInView,
    });
    var trackProductClick = function (product, idx) { return function (_) {
        if (config.isEnabled('ga4')) {
            trackSelectItem({
                element: 'tp4u',
                itemListName: 'tp4u',
                item: product,
            }, {
                customMapper: function () { return ({ index: idx }); },
            });
        }
    }; };
    var trackLastSeeAllClick = function () {
        trackSelectContent('tp4u_banner', 'click', { contentId: 'see_all_last' });
    };
    return (React.createElement(TranslateScope, { path: "myLounge.recommendations" },
        React.createElement(ResponsiveCarousel, { visibleItems: 2.2, visibleItemsXs: 3, visibleItemsMd: 3.2, visibleItemsLg: 4.2, "aria-labelledby": "top-picks-headline", 
            // TODO: A11Y - Provide localised keys.
            previousSlideLabel: "", 
            // TODO: A11Y - Provide localised keys.
            nextSlideLabel: "", withOverflow: true },
            slicedCarouselItems.map(function (article, index) {
                return (React.createElement(CarouselItem, { key: article.sku },
                    React.createElement(ArticleCompactInlineCard, { brand: article.brand, campaignIdentifier: article.campaignIdentifier, catalogType: CatalogType.TopPicks, handleOnClick: trackProductClick(article, index), media: article.media, nameCategoryTag: article.nameCategoryTag, nameColor: article.nameColor, nameShop: article.nameShop, navigationSource: NavigationSourceType.TopPicks, price: article.price, sku: article.sku, specialPrice: article.specialPrice })));
            }),
            React.createElement(CarouselItem, null,
                React.createElement(TranslateScope, { path: "myLounge.TP4U" },
                    React.createElement(S.LastSeeAll, { onClick: trackLastSeeAllClick, href: "/campaigns/top-picks/articles" },
                        React.createElement(Button, { as: "span", buttonType: ButtonType.tertiary, color: ButtonColor.dark },
                            React.createElement(Translate, { message: "cta", raw: true }))))))));
};
